import { handleErrorException, success, loading } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getInventoryBasicSetup = resourceName => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.INVENTORY_BASIC_SETUP_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(resourceName);
      dispatch(success(types.INVENTORY_BASIC_SETUP_DATA, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching information. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.INVENTORY_BASIC_SETUP_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.INVENTORY_BASIC_SETUP_LOADING, false));
    }
  };
};

export const inventoryBasicSetupDelete = (resourceName, id) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.INVENTORY_BASIC_SUBMITTING, true));
    try {
      const response = await MPWWebApi.postGenericDelete(resourceName, id);
      dispatch(success(types.INVENTORY_BASIC_SUBMITTED, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while saving setup. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.INVENTORY_BASIC_SUBMITTING_ERROR,
          defaultError
        )
      );
    } finally {
      await dispatch(getInventoryBasicSetup(resourceName));
      dispatch(loading(types.INVENTORY_BASIC_SUBMITTING, false));
    }
  };
};

export const inventoryBasicSetupInsertUpdate = (
  resourceName,
  InventoryBasicSetup
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.INVENTORY_BASIC_SUBMITTING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        resourceName,
        InventoryBasicSetup
      );
      dispatch(success(types.INVENTORY_BASIC_SUBMITTED, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while saving setup. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.INVENTORY_BASIC_SUBMITTING_ERROR,
          defaultError
        )
      );
    } finally {
      await dispatch(getInventoryBasicSetup(resourceName));
      dispatch(loading(types.INVENTORY_BASIC_SUBMITTING, false));
    }
  };
};

export const clearInventoryBasicSetupData = () => {
  return {
    type: types.INVENTORY_BASIC_SETUP_CLEAR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorybasicsetup/state/actions.js